export default __webpack_public_path__ + "static/media/greenRight.51ed2d0c.svg";